import axios from 'axios';
import {ListingApiEndpoint} from "@/beepallet.consts";
import {Bid, BidListingResult, CreateBidRequest} from "@/models/backend/BidModels";
import Session from "supertokens-web-js/recipe/session";
import {SearchResult} from "@/models/backend/SearchResult";
import { getPendingBidsCountFromListings } from './ListingService';
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import store from '@/store'; // Import store directly as a module




const apiClient = axios.create({
    baseURL: ListingApiEndpoint + '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

export const BidService = {
    async createBid(bidData : CreateBidRequest) {
        await Session.attemptRefreshingSession();
        const response = await apiClient.post('/bid', bidData);
        return response.data;
    },

    async getBidById(id : string) : Promise<BidListingResult> {
        const response = await apiClient.get(`/bid_listing/${id}`);
        const result = {
            ...response.data,
            listing: {
                ...response.data.listing,
                featureValues: (response.data.listing as any).listingFeatureValues.map((fv: any) => ({
                    ...fv,
                    featureValues: fv.featureValues.map((v: any) => v.value)
                }))
            }
        };
        return result;
    },

    async getByListingId(id : string) : Promise<Bid[]> {
        const response = await apiClient.get(`/bid/listing/${id}`);
        return response.data;
    },

    async getUserBidByListingId(listingId : string) : Promise<Bid | null> {
        try {
            const response = await apiClient.get(`/bid/user/listing/${listingId}`);
            return response.data;
        }
        catch (error) {
            console.error('Error getting user Bid By Listing Id:', error);
            return null;
        }
        
        
    },


    async getPendingBidsCountFromListings(type : string | null) : Promise<number> {
      await Session.attemptRefreshingSession();
        const typeKey = type ? type : 'ALL';
        const cacheKey = 'bid_pending_bids_' + typeKey;

        const totalInCache = LocalStorageService
            .getItemWithExpiration<{total: number}>(cacheKey);
        if(totalInCache) return totalInCache.total;

      try {
          const response = await apiClient.get('/bid/counters/pending',
              { params: { type } });

          LocalStorageService.saveItemWithExpiration(cacheKey, response.data, 2);

          return response.data.total;
      }
        catch (error) {
            console.error('Error fetching pending bids count:', error);
            throw error;
        }
    },

    // async searchBids(searchParams) {
    //     const response = await apiClient.get('/bid/search', { params: searchParams });
    //     return response.data;
    // },

    async searchUserBids(searchParams: { type?: string, pagination: {limit?: number; offset?: number} }): Promise<SearchResult<BidListingResult>> {
        await Session.attemptRefreshingSession();
        const response = await apiClient.get('/bid/user/search', { params: searchParams });

        const result = {
            ...response.data,
            results: response.data.results.map((r : BidListingResult )=> {
                return {
                    ...r,
                    listing: {
                        ...r.listing,
                        featureValues: (r.listing as any).listingFeatureValues.map((fv: any) => {
                            return {
                                ...fv,
                                featureValues: fv.featureValues.map((v: any) => v.value)
                            }
                        })
                    }
                }
            })
        };

        return result;
    },


    async acceptBid(id : string) {
        LocalStorageService.clearBidKeys();

        const response = await apiClient.put(`/bid/${id}/accept`);
        await store.dispatch('notifications/fetchNotificationCounts');
        return response.data;
    },

    async rejectBid(id : string) {
        LocalStorageService.clearBidKeys();
        const response = await apiClient.put(`/bid/${id}/reject`);
        await store.dispatch('notifications/fetchNotificationCounts');
        return response.data;
    },

    async cancelBid(id : string) {
        LocalStorageService.clearBidKeys();
        const response = await apiClient.put(`/bid/${id}/cancel`);
        await   store.dispatch('notifications/fetchNotificationCounts');
        return response.data;
    },

    async updateBid(bidData : CreateBidRequest) {
        LocalStorageService.clearBidKeys();
        await Session.attemptRefreshingSession();
        bidData.unitPrice = parseFloat(bidData.unitPrice.toString());
        bidData.quantity = parseInt(bidData.quantity.toString());

        const response = await apiClient.put(`/bid`, bidData);
        await   store.dispatch('notifications/fetchNotificationCounts');
        return response.data;
    },

    async deleteBid(id : string) {
        LocalStorageService.clearBidKeys();
        const response = await apiClient.delete(`/bid/${id}`);
        await   store.dispatch('notifications/fetchNotificationCounts');
        return response.data;
    },
};